export class Page {

  public static readonly DEFAULT_PAGE_SIZE: number = 10;

  // The number of elements in the page
  private pageSize: number;
  // The total number of elements
  private totalRecords: number | undefined;
  // The total number of pages
  private totalPages: number;
  // The current page number
  private pageNumber: number;

  constructor(pageSize: number = Page.DEFAULT_PAGE_SIZE, pageNumber: number = 0, totalRecords: number = 0) {
    this.pageSize = pageSize;
    this.pageNumber = pageNumber;
    this.totalRecords = totalRecords;
    this.calculateTotalPages();
  }

  getPageSize(): number {
    return this.pageSize;
  }

  getTotalRecords(): number | undefined {
    return this.totalRecords;
  }

  getTotalPages(): number {
    return this.totalPages;
  }

  getPageNumber(): number {
    return this.pageNumber;
  }

  updatePageSize(pageSize: number): void {
    if (this.pageSize !== pageSize) {
      this.pageSize = pageSize;
      this.calculateTotalPages();
    }
  }

  updateTotalRecords(totalRecords: number | undefined): void {
    if (this.totalRecords !== totalRecords) {
      this.totalRecords = totalRecords;
      this.calculateTotalPages();
    }
  }

  setPageNumber(pageNumber: number): void {
    this.pageNumber = pageNumber;
  }

  private calculateTotalPages(): void {
    this.totalPages = this.totalRecords !== 0 &&
    this.totalRecords !== undefined &&
    this.pageSize !== 0 ? Math.ceil(this.totalRecords / this.pageSize) : 0;
  }
}
